import { useRowsChildrenInvalidate } from "PFApp/booking/store";
import { useActivityInvalidate } from "PFCore/hooks/queries/activity";
import { useProjectsInvalidate } from "PFCore/hooks/queries/bookings/projects/use_projects_invalidate";
import { useWorkforceInvalidate } from "PFCore/hooks/queries/bookings/workforce/use_workforce_invalidate";
import { useCallback } from "react";

/**
 * Returns function to update rows after booking has been added/removed/updated
 */

export const useSyncRows = ({ syncWorkforce = true, syncProjects = true } = {}) => {
  const {
    invalidateByActivityIds: invalidateRowChildrenByActivities,
    invalidateByProfileIds: invalidateRowChildrenByProfileIds
  } = useRowsChildrenInvalidate();
  const { invalidate: invalidateProjects } = useProjectsInvalidate();
  const { invalidate: invalidateWorkforce } = useWorkforceInvalidate();
  const { invalidate: invalidateActivities } = useActivityInvalidate();

  return useCallback(
    async ({
      activityId,
      profileId,
      parentActivityIds = []
    }: {
      activityId?: number;
      profileId?: number;
      parentActivityIds: number[];
    }) => {
      if (activityId || activityId === 0) {
        const activityIdWithParentId = [...new Set([activityId, ...parentActivityIds])];
        invalidateProjects();
        invalidateRowChildrenByActivities(activityIdWithParentId);
        invalidateActivities(activityIdWithParentId);
      }

      if (!profileId) {
        return;
      }

      invalidateWorkforce();
      invalidateRowChildrenByProfileIds([profileId]);
    },
    [syncWorkforce, syncProjects]
  );
};
